module.exports = __webpack_public_path__ + "img/progress_1.cf42d104.png";